import {
  LETTER_DROP,
  LOGO_PARTS,
  LOGO_VIEWBOX,
  MARK_SHIFT,
} from './headerLogoGeometry';
import styles from './HeaderLogo.module.css';

/** px — display height of the lockup. Width matches the old wordmark box. */
const LOGO_HEIGHT = 16;
const LOGO_WIDTH = (LOGO_HEIGHT * 131.1) / 12;

/**
 * Header centre logo. Frame 0 is the Lottie wordmark, path for path.
 * Collapse and expand follow that player's timeline: 70ms lead, letters fall
 * on a 3-frame stagger, the mark travels the full 57 frames, and the way
 * back is that same segment reversed.
 */
export const HeaderLogo = ({ scrolled }: { scrolled: boolean }) => (
  <span
    className={styles.root}
    data-header-logo=""
    data-scrolled={String(scrolled)}
    style={{
      height: LOGO_HEIGHT,
      ['--mark-shift' as string]: MARK_SHIFT,
      ['--letter-drop' as string]: LETTER_DROP,
    }}
  >
    <span className={styles.sizer} aria-hidden="true">
      <svg
        width={LOGO_WIDTH}
        height={LOGO_HEIGHT}
        focusable="false"
        style={{ display: 'block' }}
      />
    </span>
    <span className={styles.frame}>
      <svg
        className={styles.graphic}
        viewBox={LOGO_VIEWBOX}
        width="1922"
        height="400"
        preserveAspectRatio="xMidYMid meet"
        aria-hidden="true"
        focusable="false"
      >
        <defs>
          <clipPath id="uh-header-logo-clip">
            <rect width="1922" height="400" x="0" y="0" />
          </clipPath>
        </defs>
        <g clipPath="url(#uh-header-logo-clip)">
          {LOGO_PARTS.map((part) => (
            <g
              key={part.id}
              className={part.kind === 'mark' ? styles.mark : styles.letter}
              style={
                part.kind === 'letter'
                  ? { ['--i' as string]: String(part.stagger) }
                  : undefined
              }
            >
              <g transform={part.transform}>
                <path d={part.d} />
              </g>
            </g>
          ))}
        </g>
      </svg>
    </span>
  </span>
);
